export enum AssetState {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
}
